import { AxiosResponse } from 'axios';
import { createApiClient } from './client';

const log = () => createApiClient('/log');

export interface LogStreamToken {
  token: string;
  expiresAt: number;
}

// 用主 JWT 换取项目日志流的短时 token（后端 60 秒过期，绑定 project_id）
export async function issueLogStreamToken(
  projectId: number,
  signal?: AbortSignal,
): Promise<AxiosResponse<LogStreamToken>> {
  return log().post('/token', { projectId }, { signal });
}
